import YYUpload from './upload.vue'

export default YYUpload